import React from "react";
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Zoom, Autoplay, Pagination, Navigation, EffectCube } from "swiper";
import { bannerData } from "../../Datas/PersonalData/bannerData";
const link = "https://youtube.com";
const SliderBanner = () => {
  return (
    <div className=" overflow-hidden container mx-auto ">
      <Swiper
        spaceBetween={10}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="banner-container"
      >
        {bannerData.map((val, i) => (
          <SwiperSlide key={i} className="my-auto overflow-hidden flex items-center justify-center">
            <a href={val.link} target="_blank" rel="noreferrer noopener">
              <img
                className="mx-auto w-full origin-cover aspect-video"
                src={val.src}
                alt={val.title}
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SliderBanner;
